import { memo, useMemo, } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalBody, BzButton, BzModalFooter } from '../../components';
import { LAYOUT_TYPE, ORDERBOOK_API_ORDER_STATUS, ORDERS_LIMIT_IN_API, ORDERS_TABKEY, ORDER_TYPES, ORDER_VALIDITY, POSITION_TYPES, SESSION_STORAGE_KEYS } from "../../utils/global_variables";
import { useSelector, useDispatch } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { getAllMultiScripOrders, getAllMultilegOrdersSuccess, getAllOrders, getAllSipOrders, getAllSpreadOrders, getAllSpreadOrdersSuccess, getMarketStatusFailure, getMultiLegData, getSpreadOrderSuccess, getplaceMultilegOrderFailure, orderMarginInfoFailure, placeSingleScripOrderFailure, placeSipOrderFailure } from '../../redux/actions/orders';
import OrderStatusBody from './OrderStatusBody';
import { squareOffPositionSuccess } from '../../redux/actions/netPosition';
import { useNavigate } from 'react-router-dom';
import { toastConfig } from '../../redux/actions/toast';
import { getMessagesOrders } from '../../redux/actions/messages';

const isHistoryAllowed = true


const OrderStatus = ({ layoutType = LAYOUT_TYPE.HORIZONTAL, setToggleBracketOrder, setOrderInputs, setLegDataInfo, setActiveTabKey, setThirdLegData, setSelectOrderOption, setOrderEntryTab, defaultGtdDate, ordersTabKey }) => {

    const dispatch = useDispatch();
    const { modals } = useSelector(state => state.modals);
    const objModalData = useSelector(state => state.modals?.modalData?.data);
    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
    const currentDate = new Date().toLocaleDateString("en-CA").split("/").reverse().join('-');
    //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End

    const { moreConversionData = {}, selectOrderOption = '', objScripData, scripOrderInfo, orderEntryTab, activeTabKey, isRemoveScrip, isCancel, isSquareOf,
        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
        isMultipleCancel = false, sipStatusType, orderInputs
        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
    } = useMemo(() => {
        if (objModalData && Object.keys(objModalData).length > 0) {
            return objModalData;
        } else {
            return { objScripData: {}, scripOrderInfo: [], orderEntryTab: '', activeTabKey: '', orderInputs: {} };
        }
    }, [objModalData]);

    const handleClose = () => {
        dispatch(getSpreadOrderSuccess({}));
        // dispatch(getMessagesOrders({ pageNo: 1 })); /* Deepti B. 110050: get recently placed order message */
        if (setToggleBracketOrder || setOrderInputs || setLegDataInfo || setOrderEntryTab || setActiveTabKey || setThirdLegData || setSelectOrderOption) {

            setToggleBracketOrder(curr => ({ ...curr, isShow: false }));
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            setOrderInputs({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0, protPercent: 0, startDate: currentDate, gtdDate: defaultGtdDate, targetSelPrice: 0, targetSelTriggerPrice: 0 });// Azeem K : 01-04-2025: Breeze-131 : Breeze - Introduction of GTT orders- OCO (One Cancels Other)  
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Ends
            setLegDataInfo([]);
            setOrderEntryTab(ORDER_TYPES.SINGLE_SCRIP);
            setThirdLegData([]);
            setSelectOrderOption(objModalData?.objSelectOrderOptionInit);
        }
        dispatch(toastConfig({ show: false }));
        dispatch(placeSingleScripOrderFailure({})); // Important
        dispatch(placeSipOrderFailure({})); // Important
        dispatch(getplaceMultilegOrderFailure([])); // Important
        dispatch(orderMarginInfoFailure(null));
        dispatch(handleModalData({}));
        dispatch(getMarketStatusFailure([]));
        dispatch(handleModal([{ 'ORDER_STATUS': false }, { "RECOMMENDATION_FOLLOW_UP_MODAL": false }]));
        dispatch(squareOffPositionSuccess({}));
        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
        if ((isCancel || isMultipleCancel) && orderEntryTab === ORDER_TYPES.SINGLE_SCRIP) {
            if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
            } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {

                dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
            } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) {

                dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS }));
            }
        }
        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
        dispatch(getMultiLegData([])); // Ajitesh 02-07-2024 Empty multi leg data for next render of order entry modal
    };
    const navigate = useNavigate();
    const routeChange = () => {
        // dispatch(getMessagesOrders({ pageNo: 1 })); /* Deepti B. 110050: get recently placed order message */
        if (orderEntryTab === ORDER_TYPES.SINGLE_SCRIP) {
            var path = "/orders?section=single_scrip";
            //  Azeem K : 27-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSEEQ  - Start 
            if (objScripData?.validity === ORDER_VALIDITY.GTT || objScripData?.validity === ORDER_VALIDITY.GTD) {//BREEZE : 132 : Breeze - Introduction of GTT orders : Azeem K : 11-03-2025 // Azeem K:07-05 - 2025 : added conditionally GTT and GTD 
                //  Azeem K : 27-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSEEQ  - Start 
                path = "/orders?section=" + ORDER_TYPES.GOOD_TILL_DATE;
            } else { }
        } else if (orderEntryTab === ORDER_TYPES.EQUITY_SIP) {
            path = "/orders?section=sip";
            // Vinit Raut : 29-01-2024 : BT-107418 - Breeze – SIP Order book -- Start 
            dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }, isHistoryAllowed));
            // Vinit Raut : 29-01-2024 : BT-107418 - Breeze – SIP Order book -- End
            sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
        } else if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP) {
            if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.SPREAD) {
                path = "/orders?section=spread";
                sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
                dispatch(getAllSpreadOrdersSuccess([]));
                dispatch(getAllSpreadOrders({ offSet: 1, limit: 20, spread: true, orderStatus: -1 }));
            } else if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.MULTI_LEG) {
                path = "/orders?section=multi_leg";
                sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
                dispatch(getAllMultilegOrdersSuccess([])); // Ajitesh 15-07-2024 - Multileg Pagination
                dispatch(getAllMultiScripOrders({ offSet: 1, limit: 20, multileg: true, orderStatus: -1 }));
            }
            //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
            else if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.BASKET) {
                path = "/orders?section=basket";
            }
            //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
        } else if (orderEntryTab === POSITION_TYPES.NET_POSITION) {
            /*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - Start*/
            path = "/orders?section=single_scrip";
            /*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - End*/
        }
        else { }

        handleClose();
        // window.location.href = path; // TO persist watchlist open tabs after order status cliked from orders screen to watchlist back this was commented Ameersha N

        navigate(path);
    };



    return (
        <Container>
            <BzModal size='md' show={modals['ORDER_STATUS']} onHide={handleClose}>
                <BzModalBody>
                    <OrderStatusBody moreConversionData={moreConversionData} selectOrderOption={selectOrderOption} layoutType={layoutType} isRemoveScrip={isRemoveScrip} activeTabKey={activeTabKey} objScripData={objScripData} scripOrderInfo={scripOrderInfo} orderEntryTab={orderEntryTab} orderId={objModalData?.orderId} isCancel={isCancel}
                        // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- Start 
                        isMultipleCancel={isMultipleCancel} arrBucketOrderIds={objModalData?.arrOrderIds} isSquareOf={isSquareOf} sipStatusType={sipStatusType} orderInputs={orderInputs}
                    // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- End 
                    />
                </BzModalBody>
                {
                    !isCancel && !isMultipleCancel &&
                    <BzModalFooter>
                        <Container fluid className='p-0 m-0'>
                            <Row className='g-0'>
                                {isRemoveScrip ?
                                    <Col md={3} className='d-flex justify-content-center align-items-center'>
                                        <BzButton className='btn btn-md btn-block btn-primary' onClick={handleClose}>OK</BzButton>
                                    </Col>
                                    :
                                    <>
                                        <Col className='d-flex justify-content-center align-items-center'>
                                            {!isSquareOf &&
                                                <BzButton className='btn btn-md btn-outline me-2' onClick={handleClose}>Close</BzButton>
                                            } {/*Azeem K :19-12-2023: added isSquareOf for hide the close button in order status modal*/}
                                            {!isCancel &&
                                                <BzButton className='btn btn-md btn-primary ms-2' onClick={routeChange}>View Order Status</BzButton>
                                            }
                                        </Col>
                                    </>
                                }
                            </Row>
                        </Container>
                    </BzModalFooter>
                }
            </BzModal>
        </Container>
    );
};

export default memo(OrderStatus);